import { render, staticRenderFns } from "./ChannelSettingsForm.vue?vue&type=template&id=31e463e9&scoped=true"
import script from "./ChannelSettingsForm.vue?vue&type=script&lang=ts"
export * from "./ChannelSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./ChannelSettingsForm.vue?vue&type=style&index=0&id=31e463e9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e463e9",
  null
  
)

export default component.exports